import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PrintVersion = ({ sections }) => {
  const handlePrint = () => {
    // Create a new window for printing
    const printWindow = window.open('', '_blank');
    
    const printContent = `
      <!DOCTYPE html>
      <html>
        <head>
          <title>Mava Cold Beverages - Terms & Conditions</title>
          <style>
            body {
              font-family: 'Inter', Arial, sans-serif;
              line-height: 1.6;
              color: #1E293B;
              max-width: 800px;
              margin: 0 auto;
              padding: 20px;
            }
            .header {
              text-align: center;
              border-bottom: 2px solid #FF7A00;
              padding-bottom: 20px;
              margin-bottom: 30px;
            }
            .logo {
              color: #FF7A00;
              font-size: 24px;
              font-weight: bold;
              margin-bottom: 10px;
            }
            .subtitle {
              color: #64748B;
              font-size: 14px;
            }
            .section {
              margin-bottom: 30px;
              page-break-inside: avoid;
            }
            .section-title {
              font-size: 18px;
              font-weight: bold;
              color: #1E293B;
              margin-bottom: 15px;
              border-left: 4px solid #FF7A00;
              padding-left: 15px;
            }
            .content {
              margin-bottom: 15px;
            }
            .highlight {
              background-color: #F0F9FF;
              border-left: 4px solid #00B0FF;
              padding: 15px;
              margin: 15px 0;
            }
            ul {
              padding-left: 20px;
            }
            li {
              margin-bottom: 5px;
            }
            table {
              width: 100%;
              border-collapse: collapse;
              margin: 15px 0;
            }
            th, td {
              border: 1px solid #E2E8F0;
              padding: 8px 12px;
              text-align: left;
            }
            th {
              background-color: #F8FAFC;
              font-weight: bold;
            }
            .footer {
              margin-top: 40px;
              padding-top: 20px;
              border-top: 1px solid #E2E8F0;
              text-align: center;
              color: #64748B;
              font-size: 12px;
            }
            @media print {
              body { margin: 0; }
              .no-print { display: none; }
            }
          </style>
        </head>
        <body>
          <div class="header">
            <div class="logo">Mava Cold Beverages</div>
            <div class="subtitle">Terms & Conditions</div>
            <div class="subtitle">Last Updated: 03/11/2025</div>
          </div>
          
          ${sections?.map(section => `
            <div class="section">
              <h2 class="section-title">${section?.title}</h2>
              ${section?.content?.map(item => {
                if (item?.type === 'paragraph') {
                  return `<div class="content">${item?.text}</div>`;
                }
                if (item?.type === 'list') {
                  return `
                    <div class="content">
                      ${item?.title ? `<strong>${item?.title}</strong>` : ''}
                      <ul>
                        ${item?.items?.map(listItem => `<li>${listItem}</li>`)?.join('')}
                      </ul>
                    </div>
                  `;
                }
                if (item?.type === 'highlight') {
                  return `
                    <div class="highlight">
                      ${item?.title ? `<strong>${item?.title}</strong><br>` : ''}
                      ${item?.text}
                    </div>
                  `;
                }
                if (item?.type === 'table') {
                  return `
                    <table>
                      <thead>
                        <tr>
                          ${item?.headers?.map(header => `<th>${header}</th>`)?.join('')}
                        </tr>
                      </thead>
                      <tbody>
                        ${item?.rows?.map(row => `
                          <tr>
                            ${row?.map(cell => `<td>${cell}</td>`)?.join('')}
                          </tr>
                        `)?.join('')}
                      </tbody>
                    </table>
                  `;
                }
                return '';
              })?.join('')}
            </div>
          `)?.join('')}
          
          <div class="footer">
            <p>© ${new Date()?.getFullYear()} Mava Cold Beverages. All rights reserved.</p>
            <p>Printed on ${new Date()?.toLocaleDateString('en-IN', { 
              day: '2-digit', 
              month: '2-digit', 
              year: 'numeric' 
            })}</p>
          </div>
        </body>
      </html>
    `;
    
    printWindow?.document?.write(printContent);
    printWindow?.document?.close();
    
    // Wait for content to load then print
    setTimeout(() => {
      printWindow?.print();
      printWindow?.close();
    }, 500);
  };

  return (
    <div className="bg-muted/50 border border-border rounded-lg p-4 mb-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
            <Icon name="Printer" size={20} className="text-primary" />
          </div>
          <div>
            <h3 className="font-poppins font-semibold text-text-primary">Print Version</h3>
            <p className="text-sm text-text-secondary">Get a printer-friendly version of our terms</p>
          </div>
        </div>
        <Button
          variant="outline"
          onClick={handlePrint}
          iconName="Download"
          iconPosition="left"
          className="water-ripple"
        >
          Print Terms
        </Button>
      </div>
    </div>
  );
};

export default PrintVersion;